import React, { useCallback, useEffect, useMemo, useRef } from 'react';

import Box from '@cobalt/react-box';
import Divider from '@cobalt/react-divider';
import { ClickableItem } from '@cobalt/react-list';

import { Checkbox } from '../../../index';

import { ListorProps } from '../Listor';

interface SelectAllCheckboxProps extends ListorProps {
  selectedValue: string[];
}

function SelectAllCheckbox(props: SelectAllCheckboxProps) {
  const { selectedValue, options, selectAllText, onChangeSelectAll } = props;

  const checkboxRef = useRef<HTMLInputElement>(null);

  const enabledOptions = useMemo(() => {
    return options.filter((option) => !option.disabled);
  }, [options]);

  const enabledValues = useMemo(() => {
    return enabledOptions.map((option) => option.value);
  }, [enabledOptions]);

  const selectAll = useMemo(() => {
    return enabledValues.every((v) => selectedValue.includes(v));
  }, [enabledValues, selectedValue]);

  const indeterminate = useMemo(() => {
    const len = enabledValues.filter((v) => selectedValue.includes(v)).length;
    return len > 0 && len < options.length;
  }, [enabledValues, options.length, selectedValue]);

  const handleChangeSelectAll = useCallback(() => {
    onChangeSelectAll?.(!selectAll);
  }, [onChangeSelectAll, selectAll]);

  useEffect(() => {
    if (checkboxRef.current === null) return;
    checkboxRef.current.indeterminate = indeterminate;
  }, [indeterminate]);

  return (
    <>
      <Box padding="2">
        <ClickableItem onClick={handleChangeSelectAll}>
          <Box data-testid="selectAllCheckbox" padding="2">
            <Checkbox forwardedRef={checkboxRef} id={false} label={selectAllText} checked={selectAll} />
          </Box>
        </ClickableItem>
      </Box>

      <Divider />
    </>
  );
}

export default SelectAllCheckbox;
